module.exports = "<div class=\"mobilePhoneVerification\" id=\"ring-captcha\" data-widget data-locale=\"en\" data-mode=\"verification\" data-type=\"sms\"\r\n    ng-model=\"$ctrl.deliveryOptions.MobilePhone\"\r\n    ng-change=\"$ctrl.onOptionChange()\"\r\n    wow-mobile-phone-validator>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/mobilephonevalidator/mobile-phone-verification.directive.html
// module id = 644
// module chunks = 2